Vue.filter('getProp5Images', function (item) {
  const result = [];

  if (item && item.variationProperties) {
    item.variationProperties.forEach((propertyGroup) => {
      if (propertyGroup.properties) {
        const variationProperty = propertyGroup.properties.find(prop => prop.id == 5);

        if (variationProperty && variationProperty.values && variationProperty.values.value) {
          const arr = variationProperty.values.value.split(';');

          for (let i = 0; i < arr.length; i += 2) {
            if (arr[i + 1]) {
              result.push([arr[i], arr[i + 1]]);
            } else {
              result.push([arr[i]]);
            }
          }
        }
      }
    });
  }
  return result;
});
